export default __webpack_public_path__ + "static/media/job-icon-9.523cdc01.png";